<abc-accordion
  class="accordion-style"
  [collapsible]="true"
  [selectedIndex]="0"
  [width]="'100%'"
  [animationDuration]="300"
  [visible]="true"
  [multiple]="false"
  [dataSource]="['Test']"
>
  <div *dxTemplate="let description of 'title'" class="dx-accordion-item-title">
    {{ this.dataService.res('Ubt-Collaborator-Total-Time') }}
  </div>

  <div
    fxLayout="column"
    class="card-paddings container-card"
    fxLayoutGap="15px"
    *dxTemplate="let description of 'item'"
  >
    <dx-data-grid
      [noDataText]="noDataText"
      [searchPanel]="false"
      [dataSource]="collaborators"
      [columns]="measureService.collaboratorsTotalTimeColumns"
      [selectionMode]="'single'"
      [showRowLines]="false"
      [showColumnLines]="false"
      [filterPanel]="false"
      [rowAlternationEnabled]="false"
    >
      <dxo-export [enabled]="false"></dxo-export>
      <dxo-filter-row [visible]="false"></dxo-filter-row>
      <dxo-header-filter [visible]="false"></dxo-header-filter>

      <dxo-group-panel [visible]="false"></dxo-group-panel>
      <dxo-column-chooser [enabled]="false"> </dxo-column-chooser>
      <dxo-editing [mode]="'row'" [allowAdding]="false" [allowDeleting]="false" [allowUpdating]="false"> </dxo-editing>
    </dx-data-grid>
  </div>
</abc-accordion>
